

import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import App from '../App';
import AppRoutes from './AppRoutes';
import AuthRoutes from './AuthRouth';
import { useAuth } from 'src/Modules/Auth/Core';





const { PUBLIC_URL } = process.env;

const Navigations = () => {

    const { currentUser, auth } = useAuth()



    return (
        <BrowserRouter basename={PUBLIC_URL}>
            <Routes >
                <Route element={<App />}>

                    {
                    currentUser?.isAuthenticated  
                    // true
                    ? (

                        <>
                            <Route path="/*" element={<AppRoutes />} />
                            <Route index element={<Navigate to="/dashboard" />} />
                        </>
                    ) : (
                        <>
                            <Route path="uprc-admin/auth/*" element={<AuthRoutes />} />
                            <Route path='*' element={<Navigate to="uprc-admin/auth/" />} />
                        </>
                    )}

                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default Navigations;


